import { Link } from 'react-router-dom';
import { ArrowUpRight, KeyRound } from 'lucide-react';

export default function PlansSection() {
  return (
    <section className="card p-6">
      <div className="flex items-start gap-3">
        <div className="rounded-lg bg-indigo-500/10 p-2 text-indigo-400">
          <KeyRound className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-ink-primary">Plans</h2>
          <p className="mt-1 text-sm text-ink-secondary">
            License plans continue to live under the dedicated Licensing page.
          </p>
          <Link
            to="/licensing"
            className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-gold hover:text-gold-light"
          >
            Open Licensing
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
